export class UpdatePrivateAuctionAuthorizationStatusRequest{
    public id! : number;
    public userId! : string;
    public status? : boolean;
    public auctionId! : number;
    public propertyId! : number;
    public bidderId! : string;
    public changedBy! : string;
    public reason! : string;
}